export const DEFAULT_SENSOR_DEPTHS = Object.freeze({
  mv1: 20,
  mv2: 40,
  mv3: 60,
});

const normalizeDepth = (value, fallback) => {
  if (value === null || value === undefined || value === "") return fallback;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : fallback;
};

export const getSensorDepths = (sensor = {}) => {
  const source = sensor.sensorDepths || sensor.depths || sensor;
  return {
    mv1: normalizeDepth(source?.mv1, DEFAULT_SENSOR_DEPTHS.mv1),
    mv2: normalizeDepth(source?.mv2, DEFAULT_SENSOR_DEPTHS.mv2),
    mv3: normalizeDepth(source?.mv3, DEFAULT_SENSOR_DEPTHS.mv3),
  };
};

export const getSensorDepthList = (sensor = {}) => {
  const depths = getSensorDepths(sensor);
  return [depths.mv1, depths.mv2, depths.mv3];
};
